import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id, PagedResponse, getQueryKey } from '@feature/utils';

import * as api from './UserApi';
import { LocalUserParams, User, UserCreateRequest } from './UserTypes';

const userKey = getQueryKey('user');

export function getUserLocalPagedOptions(params: LocalUserParams): UseSuspenseQueryOptions<PagedResponse<User>> {
  return {
    queryKey: userKey.as(['local', params]),
    queryFn: () => api.getLocalPaged(params),
  };
}

export function useUserCreate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: UserCreateRequest) => api.create(request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: userKey.root(),
      }),
  });
}

export function useUserTemporaryPasswordReissue(userId: Id) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.reissueTemporaryPassword(userId),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: userKey.root(),
      }),
  });
}
